import React, { useState, useEffect, useRef } from 'react';
import { Card, CardContent, Box, Grid, CardMedia, Typography } from '@mui/material';
import { Undo, Add } from '@mui/icons-material';
import DocumentoUploadProspect from '../Onboarding/shared/DocumentoUploadProspect';
import ButtonMain from '../Onboarding/shared/ButtonMain';
import AlertErroMain from '../Onboarding/shared/AlertErroMain';
import LoaderMain from '../Onboarding/shared/LoaderMain';
import {
  postEnviarDocumento,
  postExcluirDocumento,
  postExcluirDocumentoTemporario
} from '../../api/onboarding';
import { getDocumentosReprovadosCliente } from '../../api/clientSearch';
import { getClienteStatus, setClienteAtual } from '../../shared/services/User';

export default function Detalhes({
  tipo,
  clienteSelecionado = false,
  cnpjEmpresa = false,
  listaDocumentos = [],
  setListaDocumentos,
  dados,
  fecharDocumentos,
  listaTiposDocumentos,
  carregarAba,
  arquivosAceitos = ['pdf'],
  estadoUltimaPPC = '',
  qtdDocumentosAtualizados = 0
}) {
  const [isPendingIndexArq, setPendingIndexArq] = useState(false);
  const [isPendingDocumento, setPendingDocumento] = useState(false);
  const [newDocOpen, setNewDocOpen] = useState(false);
  const [listaTiposDocInseridos, setListaTiposDocInseridos] = useState([]);
  const [mostraErro, setMostraErro] = useState(false);
  const [cnpjCliente, setCnpjCliente] = useState(false);
  const [arquivoBoxSelected, setArquivoBoxSelected] = useState();
  const fallbackDocKeysRef = useRef(new WeakMap());
  const fallbackDocKeyCounterRef = useRef(0);
  const clienteInfo = getClienteStatus();

  const getDocumentoKey = doc => {
    const keyParts = [
      doc && doc.id,
      doc && doc.codigo,
      doc && doc.cod_documento,
      doc && doc.hash_arquivo,
      doc && doc.nome_arquivo
    ].filter(value => value !== undefined && value !== null && String(value).trim() !== '');

    if (keyParts.length > 0) return keyParts.map(String).join('_');

    if (!doc || typeof doc !== 'object') return `doc_${String(doc || 'vazio')}`;

    if (!fallbackDocKeysRef.current.has(doc)) {
      fallbackDocKeyCounterRef.current += 1;
      fallbackDocKeysRef.current.set(doc, `doc_fallback_${fallbackDocKeyCounterRef.current}`);
    }

    return fallbackDocKeysRef.current.get(doc);
  };

  useEffect(() => {
    setCnpjCliente(
      clienteSelecionado && clienteSelecionado.cnpj ? clienteSelecionado.cnpj : cnpjEmpresa
    );
  }, [clienteSelecionado, cnpjEmpresa]);

  const clickDocumento = (indexArquivo, arquivo) => {
    const arqSelected = { ...arquivo };
    if (arqSelected.novo_doc_lista === undefined || arqSelected.novo_doc_lista.length === 0) {
      arqSelected.indexArquivo = indexArquivo;
      setArquivoBoxSelected(arqSelected);
    }
  };

  const novoDocumento = () => {
    const podeDuplicar =
      clienteSelecionado.qtd_documento_reprovado > 0 ||
      (clienteSelecionado.limiteVencendo === 'S' && qtdDocumentosAtualizados === 0)
        ? false
        : true;

    if (newDocOpen === true || listaDocumentos === undefined) return false;

    const listaDocsTemp = [...listaDocumentos];
    const lstTiposDoc = listaTiposDocumentos.filter(tipoDoc =>
      podeDuplicar ? listaTiposDocInseridos.includes(tipoDoc.CODPPCDOCUMENTO) === false : true
    );
    listaDocsTemp.unshift({ id: 'new_doc', novo_doc_lista: lstTiposDoc });
    setListaDocumentos(listaDocsTemp);
    return true;
  };

  const deletarArquivo = (hashArquivo, indexArquivo) => {
    return new Promise((resolve, reject) => {
      const condPodeDeletarTemp =
        (clienteSelecionado.qtd_documento_reprovado === 0 && clienteInfo.ppc_status === null) ||
        (qtdDocumentosAtualizados === 0 && clienteSelecionado.limiteVencendo === 'S');
      if (condPodeDeletarTemp) {
        const payload = {
          cnpj: cnpjCliente,
          hash: listaDocumentos[indexArquivo].nome_arquivo,
          codigo_arquivo:
            listaDocumentos[indexArquivo].codigo || listaDocumentos[indexArquivo].cod_documento
        };
        setPendingIndexArq(indexArquivo);

        postExcluirDocumentoTemporario(payload)
          .then(response => {
            const sucesso = response.data && response.data.sucesso;
            if (sucesso) {
              // Limpa o item na lista (isso também faz o filho recalcular)
              setListaDocumentos(prev => {
                const nova = [...prev];
                const atual = { ...nova[indexArquivo] };
                delete atual.nome_arquivo;
                delete atual.hash_arquivo;
                delete atual.preview_url;
                atual.status = 'pendente';
                atual.titulo_status = 'Pendente';
                atual.subtitulo_status = '';
                nova[indexArquivo] = atual;
                return nova;
              });
              resolve(true);
            } else {
              setMostraErro({ data: { mensagem: 'Não encontrado ou hash ambíguo.' } });
              resolve(false);
            }
          })
          .catch(err => {
            setMostraErro(err.response || { data: { mensagem: 'Falha ao excluir temporário.' } });
            reject(err);
          })
          .finally(() => setPendingIndexArq(false));
      } else {
        const payload = { cnpj: cnpjCliente, codigo_arquivo: listaDocumentos[indexArquivo].id };
        setPendingIndexArq(indexArquivo);

        postExcluirDocumento(payload)
          .then(ret => {
            if (ret.data.dados.processado) {
              setListaDocumentos([]);
              // carregarAba();
              recalcularQtdDocsReprovados();
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(err => {
            setMostraErro(err.response);
            reject(err);
          })
          .finally(() => setPendingIndexArq(false));
      }
    });
  };

  const recalcularQtdDocsReprovados = () => {
    if (clienteSelecionado && clienteSelecionado.cnpj) {
      getDocumentosReprovadosCliente(clienteSelecionado.cnpj).then(retorno => {
        const dadosReprov = retorno.data;
        if (typeof dadosReprov.qtd_documento_reprovado !== 'undefined') {
          setClienteAtual({
            ...clienteSelecionado,
            qtd_documento_reprovado: dadosReprov.qtd_documento_reprovado
          });
        }
      });
    }
  };

  const salvarNovoDocumento = (indexArquivo, tipoNovoDoc) => {
    if (
      tipoNovoDoc &&
      tipoNovoDoc.CODPPCDOCUMENTO &&
      listaDocumentos[indexArquivo] &&
      (listaDocumentos[indexArquivo].hash_arquivo || listaDocumentos[indexArquivo].nome_arquivo)
    ) {
      const docAtual = listaDocumentos[indexArquivo] || {};
      const observacaoDocumento =
        docAtual.observacao ||
        docAtual.observacao_padrao ||
        docAtual.observacao_doc ||
        (String(docAtual.explicacao_doc || '')
          .toUpperCase()
          .includes('FATURAMENTO')
          ? docAtual.explicacao_doc
          : null);

      const payload = {
        cnpj: cnpjCliente,
        documento: {
          cpf_socio: null,
          cpf_conjugue: null,
          hash: listaDocumentos[indexArquivo].hash_arquivo || listaDocumentos[indexArquivo].nome_arquivo,
          cod_documento: tipoNovoDoc.CODPPCDOCUMENTO,
          observacao: observacaoDocumento ? String(observacaoDocumento).trim() : null,
          tipo: null
        }
      };

      if (tipo === 'sociedade') {
        payload.documento.cpf_socio = dados.cpfcnpj;
        payload.documento.tipo = String(dados.tipo).toUpperCase();
        const tiposConjuge = ['socio_conjuge', 'responsavel_solidario_conjuge', 'vinculo_conjuge'];
        if (tiposConjuge.includes(dados.tipo) && dados.conjuge_de && dados.conjuge_de.cpfcnpj) {
          payload.documento.cpf_conjugue = dados.cpfcnpj;
          payload.documento.cpf_socio = dados.conjuge_de.cpfcnpj;
        }
      }

      setPendingIndexArq(indexArquivo);
      postEnviarDocumento(payload)
        .then(retorno => {
          if (retorno && retorno.data && retorno.data.dados && retorno.data.dados.processado) {
            setListaDocumentos([]);
            carregarAba();
          }
          if (retorno && retorno.data && retorno.data.erro) {
            setMostraErro(retorno.data.erro);
          }
        })
        .catch(err => {
          setMostraErro(err.response);
        })
        .finally(() => {
          setPendingIndexArq(false);
        });
    }
  };

  useEffect(() => {
    let newDoc = false;
    let lstTiposDocInsTemp = [...listaTiposDocInseridos];
    listaDocumentos.map(doc => {
      if (doc.id === 'new_doc') newDoc = true;
      if (doc.status !== 'reprovado' && doc.id !== 'new_doc') lstTiposDocInsTemp.push(doc.cod_documento);
      return doc;
    });
    setNewDocOpen(newDoc);
    setListaTiposDocInseridos(lstTiposDocInsTemp);
    setArquivoBoxSelected(listaDocumentos[0] ? listaDocumentos[0] : {});
  }, [listaDocumentos]);

  useEffect(() => {
    window.scrollTo(0, 75);
  }, []);

  const podeApagar =
    clienteSelecionado.qtd_documento_reprovado > 0 ||
    clienteInfo.ppc_status === null ||
    (clienteInfo.ppc_status && clienteInfo.ppc_status.estado_ppc !== 'FIM') ||
    (qtdDocumentosAtualizados === 0 && clienteSelecionado.limiteVencendo === 'S');

  const hasReprov = Number(clienteSelecionado.qtd_documento_reprovado) > 0;
  const bloqueiaPorLimiteSemDocs =
    Number(qtdDocumentosAtualizados) === 0 &&
    clienteSelecionado.limiteVencendo === 'S' &&
    ['FIM', 'INA'].includes(estadoUltimaPPC);
  const ppcFinalizada = clienteInfo.ppc_status && clienteInfo.ppc_status.estado_ppc === 'FIM';
  // Flags semânticas
  const isFinal = ['FIM', 'INA'].includes(estadoUltimaPPC);
  const canByReprov = !!hasReprov || !isFinal;
  const canByLimite = !bloqueiaPorLimiteSemDocs;
  const ppcIndefinida = ppcFinalizada === null;
  const ppcConcluida = ppcFinalizada === true;
  const ppcNaoConcluida = ppcFinalizada === false;

  // Regra de exibição (mostra o botão se NÃO está final e há pelo menos um motivo para permitir)
  const canRender = !isFinal && (canByReprov || canByLimite || ppcNaoConcluida);
  // Regras de desabilitar (os casos que DEVEM bloquear o clique)
  const mustBlockBecauseLimitAndNoDocsAndPpcUnknown =
    !canByReprov && bloqueiaPorLimiteSemDocs && ppcIndefinida;

  // Se quiser bloquear também quando PPC estiver CONCLUÍDA, mantenha a linha abaixo.
  // Caso contrário, remova.
  const mustBlockBecausePpcFinished = ppcConcluida;

  const disabled = mustBlockBecauseLimitAndNoDocsAndPpcUnknown || mustBlockBecausePpcFinished;

  return (
    <Grid container>
      <Grid
        item
        xl={9}
        lg={9}
        md={9}
        sm={10}
        xs={12}
        sx={{ pr: '30px', minHeight: '70vh' }}
        className="borda-cor-cinza-claro-2 borda-bottom-1"
      >
        <Grid container className="grid-documentos-cliente">
          <Grid
            item
            xl={6}
            lg={6}
            md={6}
            sm={12}
            xs={12}
            sx={{ pl: '85px' }}
            className="texto-esquerda texto-negrito"
          >
            DOCUMENTO
          </Grid>
          <Grid item xl={5} lg={5} md={5} sm={12} xs={12} className="texto-esquerda texto-negrito">
            ARQUIVO
          </Grid>
          <Grid item xl={1} lg={1} md={1} sm={12} xs={12} />
        </Grid>
        {listaDocumentos.length > 0 && cnpjCliente ? (
          <>
            {listaDocumentos.map((doc, index) => {
              let classesAdicionais =
                index + 1 === listaDocumentos.length ? 'borda-transparente' : 'borda-cor-cinza-claro';
              classesAdicionais +=
                typeof (arquivoBoxSelected && arquivoBoxSelected.indexArquivo) !== 'undefined' &&
                arquivoBoxSelected.indexArquivo === index &&
                arquivoBoxSelected.id !== 'new_doc'
                  ? ' box-selected fundo-cor-cinza-claro'
                  : '';
              return (
                <Box
                  key={getDocumentoKey(doc)}
                  sx={isPendingIndexArq === index ? { position: 'relative' } : {}}
                >
                  {isPendingIndexArq === index && <LoaderMain tipoLoader="float" tipoImagem="circulo" />}
                  <DocumentoUploadProspect
                    key={doc.id}
                    id={doc.id}
                    indexArquivoFixo={index}
                    boxClassesAdicionais={classesAdicionais}
                    isPending={isPendingDocumento}
                    setPending={setPendingDocumento}
                    listaDocs={listaDocumentos}
                    setListaDocs={setListaDocumentos}
                    arquivosAceitos={arquivosAceitos}
                    tamanhoMaximoMegaAceito={30}
                    boxUploadAction={clickDocumento}
                    tipoComponente="basico"
                    cnpjEmpresa={cnpjCliente}
                    funcaoSalvarNovoDocumento={salvarNovoDocumento}
                    funcaoDeletar={doc.id !== 'new_doc' || podeApagar ? deletarArquivo : undefined}
                    permitirDeletar={
                      doc.status === 'reprovado' || doc.id === 'new_doc' || podeApagar ? true : false
                    }
                    renomearArquivoPorTipoDocumento={tipo === 'empresa'}
                    estadoUltimaPPC={estadoUltimaPPC}
                    qtdDocumentosAtualizados={qtdDocumentosAtualizados}
                  />
                </Box>
              );
            })}
          </>
        ) : (
          <Box className="borda-cor-cinza-claro flex-box-items-centralizados w-100 pad-topbot-20">
            Nenhum Documento incluído
          </Box>
        )}
      </Grid>
      <Grid item xl={3} lg={3} md={3} sm={2} xs={12}>
        <Card
          className="fundo-cor-cinza borda-cor-cinza-claro-2 borda-left-1 borda-bottom-1 border-radius-0 box-shadow-none"
          sx={{ mr: '-30px', mt: '-56px', minHeight: 'calc(100% + 56px)' }}
        >
          <CardContent>
            <Box
              sx={{ p: '40px 0 15px 0', mb: '25px' }}
              className="borda-bottom-1 borda-cor-cinza-claro-2"
            >
              <Typography variant="h6" className="texto-cor-cinza-escuro texto-weight-600">
                Detalhes da Documentação
              </Typography>
            </Box>

            <CardMedia>
              <Box>
                <h2 className="texto-cor-cinza-escuro">Documento</h2>
              </Box>
              <Box>
                <p className="texto-cinza-escuro">
                  {arquivoBoxSelected && arquivoBoxSelected.nome_doc
                    ? arquivoBoxSelected.nome_doc
                    : 'Nenhum Documento Selecionado'}
                </p>
              </Box>
              {dados && dados.nome && (
                <>
                  <Box>
                    <h2 className="texto-cor-cinza-escuro">Nome</h2>
                  </Box>
                  <Box>
                    <p className="texto-cinza-escuro">{dados.nome}</p>
                  </Box>
                </>
              )}
              {dados && dados.tipoSociedadeLabel && (
                <>
                  <Box>
                    <h2 className="texto-cor-cinza-escuro">Tipo Sociedade</h2>
                  </Box>
                  <Box>
                    <p className="texto-cinza-escuro">{dados.tipoSociedadeLabel}</p>
                  </Box>
                </>
              )}
              <Box>
                <h2 className="texto-cor-cinza-escuro">Status</h2>
              </Box>
              <Box>
                <p className="texto-cinza-escuro">
                  {arquivoBoxSelected && arquivoBoxSelected.titulo_status
                    ? arquivoBoxSelected.titulo_status
                    : 'Nenhum Documento Selecionado'}
                </p>
              </Box>
              <Box>
                <h2 className="texto-cor-cinza-escuro">Observação</h2>
              </Box>
              <Box>
                <p className="texto-cinza-escuro">
                  {arquivoBoxSelected &&
                  arquivoBoxSelected.status &&
                  arquivoBoxSelected.status === 'analise' ? (
                    <>
                      Estamos analisando o documento enviado.
                      <br />
                      <br />
                      Em caso de dúvidas fale com a gente via chat
                    </>
                  ) : (
                    <>
                      {arquivoBoxSelected &&
                      arquivoBoxSelected.pareceres &&
                      arquivoBoxSelected.pareceres.length > 0 ? (
                        <>
                          {arquivoBoxSelected.pareceres.map((item, index) => {
                            return (
                              // eslint-disable-next-line react/no-array-index-key
                              <span key={'parecer' + index}>
                                {item.retorno_parecer}
                                <br />
                                <br />
                              </span>
                            );
                          })}
                        </>
                      ) : (
                        '---'
                      )}
                    </>
                  )}
                </p>
              </Box>
            </CardMedia>
          </CardContent>
        </Card>
      </Grid>
      {mostraErro !== false && (
        <Grid item lg={12}>
          <AlertErroMain autoFocus exibeErro={mostraErro} escondeErro={setMostraErro} />
        </Grid>
      )}

      <Grid container item lg={12}>
        <Grid item xl={3} lg={3} md={3} sm={4} xs={5}>
          <ButtonMain
            tipoBotao="transparente-com-bordas-complementar"
            className="margin-top-label"
            disabled={isPendingDocumento}
            onClick={() => fecharDocumentos()}
          >
            <Undo />
            Voltar
          </ButtonMain>
        </Grid>
        <Grid item xl={6} lg={6} md={6} sm={4} xs={2} />
        {canRender && (
          <Grid item xl={3} lg={3} md={3} sm={4} xs={5}>
            <ButtonMain
              tipoBotao="principal-texto-branco"
              className="margin-top-label"
              disabled={disabled}
              onClick={novoDocumento}
            >
              <Add />
              Novo Documento
            </ButtonMain>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
